export const getLanguageCode = (locale = "en-US"): string => {
	const localeLowerCase = locale.toLowerCase();
	if (localeLowerCase.length > 2) {
		return localeLowerCase.split("-")[0] ?? localeLowerCase;
	}
	return localeLowerCase;
};
